const activeTooltips = /* @__PURE__ */ new Set();
function keyDownHandler(ev) {
  if (ev.key.toLowerCase() === "escape") {
    activeTooltips.forEach((tooltip) => {
      tooltip.toggleTooltip(false);
    });
  }
}
const registerActiveTooltip = (tooltip) => {
  if (activeTooltips.has(tooltip)) return;
  if (activeTooltips.size === 0)
    window.addEventListener("keydown", keyDownHandler);
  activeTooltips.add(tooltip);
};
const unregisterTooltip = (tooltip) => {
  if (!activeTooltips.has(tooltip)) return;
  activeTooltips.delete(tooltip);
  if (!activeTooltips.size) {
    window.removeEventListener("keydown", keyDownHandler);
  }
};
export {
  registerActiveTooltip,
  unregisterTooltip
};
